// import axios from "axios";
// import { baseUrl } from "../env";

// // import { useAuth } from "../Context/AuthProvider";
// // import { useDispatch } from "react-redux";
// // import { resetRValuesR } from "../scenes/Meeting/MeetingsSlice/MeetingsSlice";

// const existToken=localStorage.getItem('accessToken');
// const axiosInstance = axios.create({
//   baseURL: baseUrl,
//   headers: {
//     'Content-Type': 'application/json',
//     "Access-Control-Allow-Origin":'*'
//   },
// });
// axiosInstance.interceptors.request.use(
//   config => {
//     const existToken = localStorage.getItem('accessToken');
//     if (existToken) {
//       config.headers.Authorization = `Bearer ${existToken}`;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//     // const newAuth = useAuth();
//     // const dispatch = useDispatch();
//     // newAuth.logout();
//     // localStorage.setItem("accessToken", "");
//     // dispatch(resetRValuesR());
//     }
// );

// export default axiosInstance

import axios from "axios";
import { baseUrl } from "../env";

const existToken = localStorage.getItem('accessToken');
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": '*'
  },
});

// Interceptor برای اضافه کردن توکن به هر درخواست
axiosInstance.interceptors.request.use(
  config => {
    const existToken = localStorage.getItem('accessToken');
    if (existToken) {
      config.headers.Authorization = `Bearer ${existToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor برای مدیریت خطای توکن منقضی شده
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // حذف توکن از localStorage
      localStorage.removeItem('accessToken');
      // هدایت کاربر به صفحه لاگین
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

